import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { AESEncryption, ApiResDecrypt, noDataFound } from "../../CommonMethhods/CommonMethods";
import { Hierarchy } from "../../Configuration/API_URL";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../Components/Common/Loader";
import DeleteIcon from "../../asset/images/deletebusiness.svg"
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import SmallLoader from "../../Components/Common/smallLoader";
import searchIcon from "../../asset/images/search-icon.svg"
import downloadbrokrage from '../../asset/images/download-brokrage.svg';
import { useDebounce } from "../../Components/useDebounce";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axiosInstance from "../../CommonMethhods/axiosInstance";

export default function RegionMaster() {
    const [insertLoader, setInsertLoader] = useState(false);
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [scrollLoader, setScrollLoader] = useState(false);
    const [count, setCount] = useState();
    const [tableData, setTableData] = useState([])
    const [smallLoaderExcel, setSmallLoaderExcel] = useState(false)
    const storeToken = localStorage.getItem("ssoToken");
    const [page, setPage] = useState(1)
    const [searchInput, setSearchInput] = useState("")
    const [searchField, setSerchField] = useState(false);
    const [options, setOptions] = useState([])
    const [zonalCode, setZonalCode] = useState("")
    const [zonalId, setZonalId] = useState("")
    const dropdownRef = useRef(null);
    const [searchPage, setSearchPage] = useState(1);
    const [searchScrollLoader, setSearchScrollLoader] = useState(false);
    const [searchCount, setSearchCount] = useState()
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [hasVerticalScroll, setHasVerticalScroll] = useState(false);
    const tableBodyRef = useRef(null);
    const emailValidation = yup
        .string()
        .required("Email is required")
        .matches(
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
            "Please enter a valid email"
        )
        .test(
            "no-special-char-start",
            "Email cannot start with a special character",
            (value) => {
                console.log("value", value)
                if (!value) return false;
                const localPart = value.split("@")[0];
                return !/^[.!#$%&'*+/=?^_`{|}~-]/.test(localPart);
            }
        )
        .test(
            "dot-before-at",
            "A dot or special character cannot be right before the @ symbol",
            (value) => {
                console.log("value", value)
                if (!value) return false;
                const index = value.indexOf("@");
                if (index > 0) {
                    return /^[a-zA-Z0-9]$/.test(value[index - 1]);
                }
                return true;
            }
        )
        .test(
            "no-digit-after-at",
            "Domain part cannot contain digits",
            (value) => {
                console.log("value", value)
                const domain = value.split("@")[1];
                return domain ? !/\d/.test(domain) : true;
            }
        )
        .test(
            "no-special-char-after-at",
            "Domain cannot contain special characters (except .)",
            (value) => {
                console.log("value", value)
                const domain = value.split("@")[1];
                return domain ? /^[a-zA-Z.]+$/.test(domain) : true;
            }
        )
        .test(
            "dot-required-after-at",
            "Domain must contain at least one dot (.)",
            (value) => {
                console.log("value", value)
                const domain = value.split("@")[1];
                return domain ? domain.includes(".") : false;
            }
        )
        .test(
            "unique",
            "Email must be unique",
            function (value) {
                const { parent } = this;
                if (!parent || !Array.isArray(parent)) return true;
                // Count how many times this same value appears in the sibling emails
                const duplicateCount = parent.filter((email) => email === value).length;
                return duplicateCount <= 1;
            }
        )

        .email("Invalid email format");
    const schema = yup.object().shape({
        regionCode: yup
            .string()
            .required("Region Code is required")
            .matches(/^[A-Za-z0-9](?:[A-Za-z0-9 ]*[A-Za-z0-9])?$/, "Only alphabets, numbers and spaces are allowed"),
        regionName: yup
            .string()
            .required("Region Name is required")
            .matches(/^[A-Za-z][A-Za-z ]*$/, "Only alphabets and spaces are allowed"),
        zonalCode: yup
            .string()
            .required("Zonal code is required")
            .matches(/^[A-Za-z0-9](?:[A-Za-z0-9 ]*[A-Za-z0-9])?$/, "Only alphabets, numbers and spaces are allowed"),
        emails: yup
            .array()
            .of(emailValidation)
            .min(1, "At least one email is required")
            .max(5, "You can add up to 5 email IDs")
    });
    const {
        register,
        handleSubmit,
        control,
        watch,
        reset,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            regionCode: "",
            regionName: "",
            zonalCode: "",
            emails: [""]
        }
    });
    const debouncedValue = useDebounce(searchInput, 1000);

    useEffect(() => {
        handleSearchChange(debouncedValue);
    }, [debouncedValue]);

    const debouncedZonalCode = useDebounce(zonalCode, 1000);
    useEffect(() => {
        handleBusinessHeadName(debouncedZonalCode);
    }, [debouncedZonalCode]);

    const zonalCodeValue = watch("zonalCode");

    useEffect(() => {
        if (!zonalCodeValue || zonalCodeValue.trim() === "") {
            setValue("zonalCode", "");
        }
    }, [zonalCodeValue, setValue]);

    useEffect(() => {
        if (zonalCode?.length > 0) {
            setSearchPage(1)
        }
    }, [zonalCode])
    const handleSearchChange = (data) => {
        if (data) {
            if (data?.length > 3) {
                getRegionMasterTableData(1, 5, "grid", data);
            }
        }
        else if (searchField === true) {
            getRegionMasterTableData(1, 5, "grid", "");

        }
        setPage(1)

    };
    const handleBusinessHeadName = (data) => {
        setSearchScrollLoader(false);

        if (data) {
            if (data.length > 2) {
                setSearchPage(1);
                searchNationalData(data)

            }
        } else {
            // setFileType("");
            // setSearchInput("")
            // setSerchField(false);
            setSearchPage(1);
            searchNationalData("")
            // setScrollLoader(false);
        }


    }
    const [emailFields, setEmailFields] = useState([""]);
    const getRegionMasterTableData = async (pageNo, pageSize, fileType, searchBy) => {
        if (fileType === "grid" && pageNo > 1) {
            setLoader(false)
            setSmallLoaderExcel(false);
        }
        else if (fileType == "excel") {
            setSmallLoaderExcel(true);
            setLoader(false);

        } else {
            setSmallLoaderExcel(false);
            setLoader(true)
        }
        let payload = {
            "pageSize": pageSize,
            "pageNo": pageNo,
            "fileType": fileType,
            "searchBy": searchBy

        }
        console.log("payload", payload)
        let encPayload = AESEncryption(payload);
        try {
            const getData = await axiosInstance.post(
                Hierarchy.Get_Regional_Data,
                `"${encPayload}"`,
            );
            const res = ApiResDecrypt(getData?.data);
            if (res?.status === 0) {
                console.log("res table", res)
                if (fileType === "grid") {
                    setCount(res?.data?.totalCount)
                    if (pageNo > 1) {
                        setTableData((prev) => {
                            return [...prev, ...res?.data?.list];
                        })
                    } else {

                        setTableData(res?.data?.list);
                    }
                }
                else if (fileType === "excel") {
                    window.open(res?.data, "_self", "noopener,noreferrer");
                }
            } else {
                if (fileType === "grid") {
                    setTableData([])
                } else {
                    toast.error(res?.message);
                }

            }
            setLoader(false);
            setSmallLoaderExcel(false);
        } catch (error) {
            if (error?.request?.status == 401) {
                localStorage.clear("");
                navigate("/");
            }
        } finally {
            setLoader(false);
            setScrollLoader(false);
            setSmallLoaderExcel(false)
        }
    };
    console.log("page", page, tableData)
    useEffect(() => {
        getRegionMasterTableData(1, 5, "grid")
        // searchBusinessData()
    }, [])
    const insertRegionalTableData = async (data, action = "INSERT", srNo = "1") => {
        console.log("submit data", data)
        setInsertLoader(true);
        let payload
        if (action == "DELETE") {
            payload = {
                sno: srNo,
                action: "DELETE"
            }
        }
        else {
            payload = {
                sno: data?.sno ? data?.sno : srNo,
                action: data?.action ? data?.action : action,
                regionCode: data?.regionCode,
                zonalId: zonalId,
                regionName: data?.regionName,
                emailId1: data?.emails[0],
                emailId2: data?.emails[1],
                emailId3: data?.emails[2],
                emailId4: data?.emails[3],
                emailId5: data?.emails[4]
            }
        }
        console.log("payload", payload)
        let encPayload = AESEncryption(payload);
        try {
            const getData = await axiosInstance.post(
                Hierarchy.Insert_Regional_Data,
                `"${encPayload}"`,
            );
            const res = ApiResDecrypt(getData?.data);
            console.log("res", res)
            if (res?.status === 0) {
                toast.success(res?.data);
                getRegionMasterTableData(1, 5, "grid")
                reset({
                    regionCode: "",
                    regionName: "",
                    zonalCode: "",
                    zonalId: "",
                    emails: [""]
                });
                setZonalId("")
                setZonalCode("")
                setEmailFields([""]);
            } else {
                toast.error(res?.message);
            }
        } catch (error) {
            if (error?.request?.status == 401) {
                localStorage.clear("");
                navigate("/");
            }
        } finally {
            setInsertLoader(false);
        }
    };

    const searchNationalData = async (data) => {
        console.log("submit data", data)
        setSearchScrollLoader(true)
        let payload

        payload = {
            "pageSize": 10,
            "pageNo": searchPage,
            "searchBy": data || ""
        }

        console.log("payload", payload)
        let encPayload = AESEncryption(payload);
        try {
            const getData = await axiosInstance.post(
                Hierarchy.Search_Zonal_Head,
                `"${encPayload}"`,
            );
            const res = ApiResDecrypt(getData?.data);
            console.log("res search", res)
            if (res?.status === 0) {
                setSearchScrollLoader(false)
                // setOptions(res?.data?.list)
                setSearchCount(res?.data?.totalCount)
                if (searchPage > 1) {
                    setOptions((prev) => {
                        return [...prev, ...res?.data?.list];
                    });
                } else {
                    setOptions(res?.data?.list);
                }
            } else {
                toast.error(res?.message);
            }
        } catch (error) {
            setSearchScrollLoader(false)
            if (error?.request?.status == 401) {
                localStorage.clear("");
                navigate("/");
            }
        } finally {
            setSearchScrollLoader(false)
            setInsertLoader(false);
        }
    };
    console.log("searchpage", searchPage)
    useEffect(() => {
        if (searchPage > 1) {
            searchNationalData(debouncedZonalCode)
        }
    }, [searchPage])
    const onSubmit = (data) => {
        console.log("data", data)
        if (data.zonalCode && !zonalId) {
            toast.error("Please select a valid Zonal Code from the dropdown");
            return;
        }
        setPage(1)
        insertRegionalTableData(data)
    };

    const addEmailField = () => {
        if (emailFields.length < 5) {
            setEmailFields([...emailFields, ""]);
        }
    };

    const removeEmailField = (index) => {
        setEmailFields((prev) => {
            const updatedEmails = [...prev];
            updatedEmails.splice(index, 1)
            return updatedEmails;
        });
        const currentEmails = watch("emails") || [];
        const updatedEmailsList = [...currentEmails];
        updatedEmailsList.splice(index, 1);
        reset({ ...watch(), emails: updatedEmailsList });
    };
    function editTable(data) {
        setPage(1)
        setZonalId(data?.zonalId)
        setZonalCode(data?.zonalHeadCode)
        setEmailFields([
            data?.emailId1 || "",
            data?.emailId2 || "",
            data?.emailId3 || "",
            data?.emailId4 || "",
            data?.emailId5 || ""
        ].filter(email => email !== ""));
        reset({
            sno: data?.sno,
            action: "UPDATE",
            zonalId: data?.zonalId,
            zonalCode: data?.zonalCode,
            regionCode: data?.regionCode,
            regionName: data?.regionName,
            emails: [
                data?.emailId1 || "",
                data?.emailId2 || "",
                data?.emailId3 || "",
                data?.emailId4 || "",
                data?.emailId5 || ""
            ].filter(email => email !== "")

        })

    }

    function deletTable(data) {
        setPage(1)
        insertRegionalTableData(data, "DELETE", data?.sno)
    }
    const handleScroll = (e) => {
        const a = e.target;
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
            console.log("a", a.scrollTop, a.offsetHeight)
            // if (count!= tableData.length) {
            if (!(count <= 5 * page)) {
                console.log("count", count, tableData.length,)
                setPage((prev) => prev + 1);
                setScrollLoader(true);
                setLoader(false);
                let offset = page + 1
                getRegionMasterTableData(offset, 5, "grid", searchInput)
            }
            else {
                setScrollLoader(false);
            }
        }
    };

    const handleSearchScroll = async (e) => {
        const a = e.target;
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !searchScrollLoader) {
            if (!(searchCount <= 10 * searchPage)) {
                setSearchPage((prev) => prev + 1);
                setSearchScrollLoader(true);
            }
        }
    };
    useEffect(() => {
        const el = tableBodyRef.current;

        if (!el) return;

        const checkScroll = () => {
            setHasVerticalScroll(el.scrollHeight > el.clientHeight);
        };

        checkScroll(); // Run immediately

        const observer = new ResizeObserver(checkScroll);
        observer.observe(el);

        return () => observer.disconnect();
    }, [tableData]);

    const handlePasteInput = (fieldName) => (e) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData("text");

        let clean = pastedText.toUpperCase().replace(/[^A-Z0-9\s]/g, "")
        clean = clean.replace(/\s+/g, " ").trim();
        if (clean === "") return;

        const input = e.target;
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const currentValue = input.value;

        const newValue = (
            currentValue.slice(0, start) +
            clean +
            currentValue.slice(end)
        ).slice(0, 100);
        setValue(fieldName, newValue, { shouldValidate: true });
        if (fieldName === "zonalCode") {
            setZonalCode(newValue)
        }
        input.value = newValue;
        const cursorPos = start + clean.length;
        setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!dropdownRef.current) return;

            if (dropdownRef.current.contains(event.target)) {
                return;
            }
            setDropdownVisible(false);
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className='heirarchy-branch'>
            <form onSubmit={handleSubmit(onSubmit)}>

                <div className="row input-field-wrapper">
                    <div className="col-md-3 col-sm-3 col-12">
                        <div className="form-group">
                            <label className="form-label">
                                Region Code <span className="partner-mandetory">*</span>
                            </label>
                            <input
                                type="text"
                                className="input-st ap hierarchy-input "
                                placeholder="Enter here"
                                autoComplete="off"
                                maxLength={100}
                                onInput={(e) => {
                                    const start = e.target.selectionStart;
                                    const end = e.target.selectionEnd;

                                    let input = e.target.value;
                                    input = input
                                        .toUpperCase()
                                        .replace(/[^A-Z0-9\s]/g, "")
                                        .replace(/\s+/g, " ")
                                        .trimStart()
                                        .slice(0, 100);

                                    e.target.value = input;

                                    e.target.setSelectionRange(start, end);

                                }}
                                onPaste={handlePasteInput("regionCode")}
                                {...register("regionCode", { required: "Region Code is required" })}
                            />
                            {errors.regionCode && <p className="error-msg">{errors.regionCode.message}</p>}
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 col-12">
                        <div className="form-group">
                            <label className="form-label">
                                Region Name <span className="partner-mandetory">*</span>
                            </label>
                            <input
                                type="text"
                                className="input-st ap hierarchy-input"
                                placeholder="Enter here"
                                autoComplete="off"
                                maxLength={100}
                                onInput={(e) => {
                                    const start = e.target.selectionStart;
                                    const end = e.target.selectionEnd;

                                    let input = e.target.value;
                                    input = input
                                        .toUpperCase()
                                        .replace(/[^A-Z0-9\s]/g, "")
                                        .replace(/\s+/g, " ")
                                        .trimStart()
                                        .slice(0, 100);

                                    e.target.value = input;

                                    e.target.setSelectionRange(start, end);

                                }}
                                onPaste={handlePasteInput("regionName")}
                                {...register("regionName", { required: "Region Name is required" })}
                            />
                            {errors.regionName && <p className="error-msg">{errors.regionName.message}</p>}
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 col-12">
                        <div className="form-group">
                            <label className="form-label">
                                Zonal Code<span className="partner-mandetory">*</span>
                            </label>
                            <div className="rm-custom-dropdown">
                                <input
                                    type="text"
                                    className="input-st ap hierarchy-input"
                                    placeholder="Search..."
                                    // value={zonalCode}
                                    value={watch("zonalCode") || ""}
                                    autoComplete="off"
                                    maxLength={100}
                                    //   onChange={(e) => searchBusinessData(e.target.value)}
                                    {...register("zonalCode", { required: "Zonal Code is required" })}
                                    // onInput={(e) => {
                                    //     setZonalCode(e.target.value);
                                    // }}
                                    onInput={(e) => {
                                        const start = e.target.selectionStart;
                                        const end = e.target.selectionEnd;

                                        let input = e.target.value;
                                        input = input
                                            .toUpperCase()
                                            .replace(/[^A-Z0-9\s]/g, "")
                                            .replace(/\s+/g, " ")
                                            .trimStart()
                                            .slice(0, 100);

                                        e.target.value = input;

                                        e.target.setSelectionRange(start, end);
                                        setZonalCode(input);
                                    }}
                                    onPaste={handlePasteInput("zonalCode")}
                                    onFocus={() => setDropdownVisible(true)}
                                />
                                <button
                                    type="button"
                                    className="rm-dropdown-btn"
                                    onClick={() => setDropdownVisible(!dropdownVisible)}
                                >
                                    <span className="icon-right-arrow-triangle"></span>
                                </button>

                                {dropdownVisible && (
                                    <ul
                                        className="rm-mapping-ap border-0 branch-code"
                                        ref={dropdownRef}
                                        onScroll={(e) => handleSearchScroll(e)}
                                    >
                                        {options.map((option, index) => (
                                            <li
                                                className="rm-maping-item-wrapper"
                                                key={index} onClick={() => {
                                                    setZonalCode(option.zonalCode)
                                                    setDropdownVisible(false);
                                                    setValue("zonalCode", option.zonalCode, {
                                                        shouldValidate: true,
                                                        shouldDirty: true,
                                                    });
                                                    clearErrors("zonalCode");
                                                    setZonalId(option.zonalId)
                                                }}>
                                                {option.zonalCode}
                                            </li>
                                        ))}
                                        {searchScrollLoader && !loader && (
                                            <div className="loader-center">
                                                <LoaderForSearch />
                                            </div>
                                        )}
                                    </ul>
                                )}
                            </div>
                            {errors.zonalCode && <p className="error-msg">{errors.zonalCode.message}</p>}
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-3 col-12">
                        <div className="form-group">
                            <label className="form-label">
                                Email ID <span className="partner-mandetory">*</span>
                                <span className="email-label">(add upto 5 email ID)</span>
                            </label>
                            <input
                                type="text"
                                className="input-st ap hierarchy-input"
                                placeholder="Enter here"
                                autoComplete="off"
                                {...register(`emails[0]`
                                )}
                            />
                            {errors.emails?.[0] && <p className="error-msg">{errors.emails?.[0].message}</p>}
                        </div>
                        <div className={`${emailFields.length < 5 ? "addmore" : "addmore disabled"}`} disabled={emailFields.length > 5 ? true : false}>
                            <span onClick={addEmailField} style={{ cursor: "pointer" }}> + Add More</span>
                        </div>
                    </div>
                    {emailFields.slice(1).map((_, index) => (
                        <div className="col-md-3 col-sm-3 col-12" key={index + 1}>
                            <div className="form-group">
                                <label className="form-label">
                                    Email ID
                                </label>
                                {/* <Controller
                                    name={`emails[${index + 1}]`}
                                    control={control}
                                    rules={{
                                        required: "Email is required",
                                        pattern: {
                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                            message: "Invalid email format",
                                        },
                                        validate: (value) => {
                                            const emailList = watch("emails");
                                            return emailList.filter((email) => email === value).length > 1
                                                ? "Email must be unique"
                                                : true;
                                        },
                                    }}
                                    render={({ field }) => (
                                        <input
                                            type="text"
                                            className="input-st ap hierarchy-input"
                                            placeholder="Enter here"
                                            {...field}
                                            autoComplete="off"
                                        />
                                    )}
                                /> */}
                                <input
                                    type="text"
                                    className="input-st ap hierarchy-input"
                                    placeholder="Enter here"
                                    autoComplete="off"

                                    {...register(`emails[${index + 1}]`
                                        , {
                                            required: "Email is required",
                                            pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                message: "Invalid email format",
                                            },
                                            validate: (value) => {
                                                const emailList = watch("emails");
                                                return emailList.filter((email) => email === value).length > 1
                                                    ? "Email must be unique"
                                                    : true;
                                            }
                                        }
                                    )}
                                />
                                {errors.emails?.[index + 1] && (
                                    <p className="error-msg">{errors.emails[index + 1].message}</p>
                                )}
                                <button type="button" onClick={() => removeEmailField(index + 1)} className="remove-btn">
                                    <img src={DeleteIcon} alt="DeleteIcon" />
                                    Remove
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
                <button type="submit" className="text-center search-btn-wrapper">
                    Submit
                </button>



            </form>
            <div>
                <div className='search-wrapper'>
                    <div className='search-input-wrapper'>
                        <div className="rm-custom-dropdown">
                            <img src={searchIcon} alt="search" />

                            <input
                                type="text"
                                name="search-text"
                                className="input-st ap hierarchy-input"
                                // maxLength={20}
                                value={searchInput}
                                placeholder="Search by Region Code/Name"
                                autoComplete="off"
                                onChange={(e) => {
                                    setSearchInput(e?.target?.value?.toUpperCase());
                                    setSerchField(true)

                                }}
                                onInput={(e) => {
                                    const start = e.target.selectionStart;
                                    const end = e.target.selectionEnd;
                                    let input = e.target.value;
                                    input = input
                                        .toUpperCase()
                                        .replace(/[^A-Z0-9\s]/g, "")
                                        .replace(/\s+/g, " ")
                                        .trimStart()
                                        .slice(0, 100);

                                    e.target.value = input;
                                    e.target.setSelectionRange(start, end);

                                }}
                            />

                        </div>

                        <button className="dnload-btn" onClick={() => { getRegionMasterTableData(-1, -1, "excel", searchInput) }}>
                            {smallLoaderExcel ? (
                                <SmallLoader />
                            ) :
                                <>
                                    <img src={downloadbrokrage} alt="download" />
                                    Download All</>
                            }
                        </button>
                    </div>
                </div>

                <div className='business-table'>
                    {loader ? (
                        <div className="loader-alignment">
                            <Loader />
                        </div>
                    ) :
                        <div className="scroll-table master_table businessTab">
                            {tableData && tableData?.length > 0 ? (
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Sr. No</span>
                                                </span>
                                            </th>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Region Code</span>

                                                </span>
                                            </th>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Region Name</span>

                                                </span>
                                            </th>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Zonal Code</span>

                                                </span></th>
                                            <th><span className='wrap-th'>
                                                <span>Email ID 01</span>

                                            </span>
                                            </th>
                                            <th><span className='wrap-th'>
                                                <span>Email ID 02</span>

                                            </span>
                                            </th>
                                            <th><span className='wrap-th'>
                                                <span>Email ID 03</span>

                                            </span>
                                            </th>
                                            <th><span className='wrap-th'>
                                                <span>Email ID 04</span>

                                            </span>
                                            </th>
                                            <th><span className='wrap-th'>
                                                <span>Email ID 05</span>

                                            </span>
                                            </th>
                                            <th><span className='wrap-th'>
                                                <span>Actions</span>

                                            </span>
                                            </th>
                                            {hasVerticalScroll && <th className="scrollerthead"></th>}
                                        </tr>
                                    </thead>
                                    <tbody onScroll={(e) => handleScroll(e)} id="per-table-body"
                                        ref={tableBodyRef}>
                                        {tableData?.length > 0 && tableData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item?.regionCode}</td>
                                                <td>{item?.regionName}</td>
                                                <td>{item?.zonalCode}</td>
                                                <td>{item?.emailId1 || "-"}</td>
                                                <td>{item?.emailId2 || "-"}</td>
                                                <td>{item?.emailId3 || "-"}</td>
                                                <td>{item?.emailId4 || "-"}</td>
                                                <td>{item?.emailId5 || "-"}</td>
                                                <td>
                                                    <button
                                                        onClick={() => editTable(item)}
                                                        type="button"
                                                        className="icon-Edit edit-icon"
                                                        style={{ backgroundColor: "transparent" }}
                                                    >

                                                    </button>
                                                    <button
                                                        onClick={() => deletTable(item)}
                                                        type="button"
                                                        className="businessdelete"
                                                    >
                                                        <img src={DeleteIcon} alt="DeleteIcon" />
                                                    </button>
                                                </td>

                                            </tr>
                                        ))
                                        }
                                        {scrollLoader && (
                                            <div className="loader-center">
                                                <LoaderForSearch />
                                            </div>
                                        )}
                                    </tbody>
                                </table>
                            ) : noDataFound()
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
